<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import { initCertSdk } from '@/utils/certSdk';
  export default {
    name: "app",
    data() {
      return {
        network: true
      }
    },
    mounted() {
      // 检测断网
      window.addEventListener("offline", () => {
        this.$router.push({name: 'mobile_file|404'});
      });
      // 语言设置，暂只支持中、英文
      let language = window.navigator.language.toLowerCase();
      if (language.startsWith('zh')) {
        language = 'zh-CN';
      } else {
        language = 'en';
      }
      this.$i18nClient.changeLanguage(language, (err, t) => {
        if (err) {
          console.log(err);
        }
      });
      // 根证书检测 SDK 初始化（托管弹窗模式，autoPopup=true）
      initCertSdk();
    }
  }
</script>

<style>
  #app section {
    overflow: hidden;
  }

  #app section .mtd-main::-webkit-scrollbar {
    width: 0 !important
  }

  #app section .mtd-main {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }
</style>

